
export const sFechaPublicacion = '2026-09-23T23:08:51.7241123-06:00';
export const sVersion = 'vf1.1.609232308';
            